import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GenericPageLayout } from '@layout/GenericPageLayout';
import { Error500 } from '@components/common/hero/error/Error500';
import { ERROR_CODES } from '@model/common/error-codes';
import { setPartialSearch } from '@state/slices/deal-finder/dealFinderSlice';
import { getAlgoliaMatchingDestinations } from '@state/slices/algolia/algoliaSelectors';
import { DestinationMeta } from '@components/content/destination/Head/DestinationMeta';
import { Logging } from '@util/logging';
import { getDestinationSearchParams, DestinationSearchParams } from '@util/destination';
import { DestinationPageHolidaysLayoutProps } from './props';

export const DestinationPageHolidaysLayout = ({
  path,
  pageConfig,
  componentsData,
  destination,
  tripType,
  promoBannerTripType
}: DestinationPageHolidaysLayoutProps) => {
  const dispatch = useDispatch();
  const algoliaDestinations = useSelector(getAlgoliaMatchingDestinations(path));

  useEffect(() => {
    if (destination && !!algoliaDestinations.length) {
      const { display } = destination;
      const defaultSearchParams = getDestinationSearchParams({
        display,
        path,
        destinations: algoliaDestinations
      } as DestinationSearchParams);
      dispatch(setPartialSearch(defaultSearchParams));
    }
  }, [path, algoliaDestinations]);

  if (!pageConfig) {
    Logging.warn({ text: `No pageConfig for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;
  }
  if (!destination) {
    Logging.warn({ text: `No destination for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_API_DESTINATION} />;
  }

  const { components } = pageConfig;

  return (
    <>
      <GenericPageLayout
        components={components}
        componentsData={componentsData}
        tripType={tripType}
        path={path}
        destination={destination}
        promoBannerTripType={promoBannerTripType}
      />
      <DestinationMeta components={components} destination={destination} tripType={tripType} />
    </>
  );
};
